import { gsap } from "gsap";
import SplitText from 'gsap/SplitText';
gsap.registerPlugin(SplitText);

export default class FlipButton {

	constructor(container, options) {
		this.label = container;
		this.container = container.parentNode;
		const defaults = {
			button: container.parentNode.parentNode,
			position: 'absolute',
			left: 0,
			from: 'end',
			amount: 0.1,
			fade: true
		};

		this.options = Object.assign({}, defaults, options);
		this.button = this.options.button;
		this.tl = null;

		this.init();
	}

	init = () => {
		this.events();
		if (this.options.fade) this.fade();
	}
	events = () => {
		this.button.addEventListener("mouseenter", this.onEnter, false);
		this.button.addEventListener("mouseleave", this.onLeave, false);
	}

	// The clone + SplitText + timeline are built on first hover, not at init.
	// Every product card has one, and building them all up front was ~1.1s of
	// blocked main thread on a mid-range phone, where the hover never happens.
	build = () => {
		let clonedBtn = this.label.cloneNode(true);
		clonedBtn.classList.remove('position-relative');

		gsap.set(clonedBtn, { position: this.options.position, left: this.options.left });

		this.container.appendChild(clonedBtn);

		this.splitLabel_1 = new SplitText(this.label, { type: "chars" });
		this.splitLabel_2 = new SplitText(clonedBtn, { type: "chars" });

		this.tl = gsap.timeline({ paused: true })
		this.create();
	}

	create = () => {

		this.tl.to(this.splitLabel_1.chars, { y: "-100%", opacity: 0, duration: .3, stagger: { amount: this.options.amount, from: this.options.from }, delay: 0, ease: 'power2.inOut' });
		this.tl.from(this.splitLabel_2.chars, { y: "100%", opacity: 0, duration: .3, stagger: { amount: this.options.amount, from: this.options.from, }, delay: 0, ease: 'power2.inOut' }, '<');
	}

	fade = () => {
		gsap.fromTo(this.button, { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 0.8, scrollTrigger: { trigger: this.container }, ease: 'expo.out' });
	}

	onEnter = () => {
		if (!this.tl) this.build();
		this.tl.play();
	}

	onLeave = () => {
		this.tl?.reverse();
	}

	destroy = () => {
		//console.log('Destroy FlipButton');

		this.button.removeEventListener("mouseenter", this.onEnter, false);
		this.button.removeEventListener("mouseleave", this.onLeave, false);

		this.container = null;
		this.button = null;
		this.tl = null;
	}
}
